module.exports = __webpack_public_path__ + "media/images/taliform-aced94bd9426589c69531df0a2aa6b93.png";